/**
 * Created by tbhasme on 08-10-2017.
 */
export enum SurveyMcqOptionAction {
  ADD = <any>'ADD',
  EDIT = <any>'EDIT',
  DELETE = <any>'DELETE'
}


// WEBPACK FOOTER //
// ./src/app/shared/models/survey/survey-mcq-option-action.enum.ts